import React from 'react';
import { Box, Typography, List, ListItem, ListItemText } from '@mui/material';
import { FnPageLogoDown } from '../../Public/Home/Index';

const cardStyle = {
  backgroundColor: 'rgba(0, 0, 0, 75%)',
  borderRadius: '10px',
  padding: '20px',
  color: 'white',
  boxShadow: 'rgb(0, 0, 0) 10px 10px 20px 0px',
  width: '90vw',
  maxWidth: '900px',
  margin: '20px auto',
};

function Section({ title, children }) {
  return (
    <Box sx={cardStyle}>
      <Typography variant="h5" sx={{ color: 'orange', marginBottom: '12px' }}>
        {title}
      </Typography>
      {children}
    </Box>
  );
}

const bodySx = { color: '#e0e0e0', mb: 1.5, lineHeight: 1.6 };
const listItemSx = { color: '#e0e0e0', py: 0.25 };

export default function Welcome() {
  return (
    <FnPageLogoDown>
      <Box
        sx={{
          flex: 1,
          minHeight: 0,
          padding: '10px 0',
          width: '100%',
        }}
      >
        <Box sx={{ textAlign: 'center', marginTop: '10px', px: 2 }}>
          <Typography variant="h4" sx={{ color: 'white', fontWeight: 600 }}>
            Bem-vindo!
          </Typography>
          <Typography variant="body1" sx={{ color: '#cccccc', marginTop: '8px' }}>
            Seja bem-vindo à área privativa do <strong>Mette App</strong>.
          </Typography>
        </Box>

        <Section title="Sobre este ambiente">
          <Typography sx={bodySx}>
            Este ambiente foi criado para concentrar projetos, experimentos e
            ferramentas desenvolvidas por mim. Aqui você encontrará aplicações
            em desenvolvimento, dashboards, integrações, protótipos, recursos
            utilizando Inteligência Artificial e outras soluções que fazem
            parte dos meus estudos e do meu trabalho.
          </Typography>
        </Section>

        <Section title="Objetivo desta Área">
          <Typography sx={bodySx}>
            O principal objetivo deste espaço é servir como um laboratório de
            desenvolvimento.
          </Typography>
          <Typography sx={bodySx}>
            As funcionalidades disponibilizadas aqui podem estar em diferentes
            estágios de evolução, desde provas de conceito até ferramentas mais
            completas. Algumas podem sofrer alterações frequentes, serem
            removidas ou substituídas conforme novos estudos e tecnologias forem
            surgindo.
          </Typography>
          <Typography sx={bodySx}>
            Nem todas as ferramentas são destinadas ao uso público ou comercial,
            sendo muitas delas utilizadas para testes, validações técnicas e
            demonstrações.
          </Typography>
        </Section>

        <Section title="Inteligência Artificial">
          <Typography sx={bodySx}>
            Algumas funcionalidades utilizam modelos de Inteligência Artificial
            para auxiliar na geração de conteúdo, automação de tarefas e
            experimentação de novas ideias.
          </Typography>
          <Typography sx={bodySx}>
            Embora essas ferramentas sejam úteis, as respostas geradas pela IA
            podem conter imprecisões ou interpretações incorretas. Sempre que
            necessário, valide as informações antes de utilizá-las como fonte
            de decisão.
          </Typography>
        </Section>

        <Section title="Diretrizes de Uso">
          <Typography sx={bodySx}>
            Ao utilizar esta área, você concorda em fazer um uso responsável
            das ferramentas disponibilizadas.
          </Typography>
          <Typography sx={bodySx}>
            Não é permitido utilizar qualquer funcionalidade para:
          </Typography>
          <List dense disablePadding sx={{ mb: 1.5, pl: 1 }}>
            {[
              'Ofender, assediar ou atacar pessoas ou grupos;',
              'Produzir conteúdo com injúria, difamação ou calúnia;',
              'Incentivar atividades ilegais ou prejudiciais;',
              'Compartilhar conteúdos discriminatórios, violentos ou de ódio;',
              'Tentar explorar vulnerabilidades, burlar limitações ou comprometer a segurança da plataforma.',
            ].map((text) => (
              <ListItem key={text} sx={{ py: 0.25, display: 'list-item', listStyleType: 'disc', ml: 2 }}>
                <ListItemText
                  primary={text}
                  primaryTypographyProps={{ sx: listItemSx }}
                />
              </ListItem>
            ))}
          </List>
          <Typography sx={bodySx}>
            O acesso poderá ser restringido ou removido caso seja identificado
            qualquer uso incompatível com esses princípios.
          </Typography>
        </Section>

        <Section title="Privacidade">
          <Typography sx={bodySx}>
            Sempre que possível, evite informar dados pessoais, informações
            confidenciais ou qualquer conteúdo sensível durante a utilização
            das ferramentas.
          </Typography>
          <Typography sx={bodySx}>
            Embora medidas de segurança sejam adotadas, nenhum sistema é
            totalmente livre de riscos.
          </Typography>
        </Section>

        <Section title="Em constante evolução">
          <Typography sx={bodySx}>
            Este ambiente está em desenvolvimento contínuo.
          </Typography>
          <Typography sx={bodySx}>
            Novas funcionalidades poderão ser adicionadas, modificadas ou
            removidas sem aviso prévio, acompanhando minha evolução
            profissional e os projetos que desenvolvo.
          </Typography>
          <Typography sx={{ ...bodySx, mb: 0 }}>
            Obrigado pela visita e aproveite para explorar as ferramentas
            disponíveis!
          </Typography>
        </Section>
      </Box>
    </FnPageLogoDown>
  );
}
